import { PageHero } from '../components/PageHero';
import { ServiceCard } from '../components/ServiceCard';
import { CTASection } from '../components/CTASection';
import { services } from '../data/services';
import { usePageMeta } from '../components/ScrollToTop';

export default function Services() {
  usePageMeta(
    'Our Services — TheBigHub | 8 Digital Growth Solutions',
    'Explore TheBigHub\u2019s eight core services: social media management, Google Ads & SEO, website development, digital trainings, courses, content production, research writing, and branding.'
  );
  return (
    <main data-testid="services-page">
      <PageHero
        eyebrow="Our Services"
        title="Everything Your Business Needs to Grow Digitally."
        copy="Eight powerful solutions. One dedicated digital growth partner. Explore each service to see exactly how we can help."
      />
      <section className="bg-cream">
        <div className="mx-auto max-w-7xl px-5 py-20 sm:px-8 sm:py-28">
          <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {services.map((s, i) => (
              <ServiceCard key={s.slug} service={s} index={i} />
            ))}
          </div>
        </div>
      </section>
      <CTASection />
    </main>
  );
}
